export default "__VITE_ASSET__DV1P0Gvq__"